import * as moment from 'moment-timezone';

export enum TranslationStatus {
      Source = 0,
      Automatic = 1,
      Verified = 2
}

export interface PostSeo {
      Id: string;
      Title: string;
      Url: string;
      CompanyId: string;
      PublicationDate: moment.Moment;
      CreationDate: moment.Moment;
      AuthorId: string;
      FeedId: string;
      LanguageId: string;
      Content: string;
      Tags: string[];
      ImageUrl: string;
      ImageCaption: string;
      ImageCopyright: string;
      SeoMetaTitle: string;
      SeoMetaDescription: string;
      SeoKeyWords: string;
      SeoUrl: string;
      IsDraft?: boolean;
      TranslationStatus: TranslationStatus;
      TranslationSourceId?: string;
}

export interface DraftSeo {
      Id: string;
      Title: string;
      Url: string;
      CompanyId: string;
      PublicationDate: moment.Moment;
      CreationDate: moment.Moment;
      AuthorId: string;
      FeedId: string;
      LanguageId: string;
      Content: string;
      Tags: string[];
      ImageUrl: string;
      ImageCaption: string;
      ImageCopyright: string;
      SeoMetaTitle: string;
      SeoMetaDescription: string;
      SeoKeyWords: string;
      SeoUrl: string;
      IsDraft?: boolean;
      Type: number;
      Status: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/PostSeo.ts